import { SET_TOASTER_MESSAGE } from './common.actiontype';

export const setToasterMessage = (data) => async (dispatch) => {
  dispatch({ type: SET_TOASTER_MESSAGE, payload: data });
};

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
